import { Button } from '@mui/material';
import Iconify from 'src/components/iconify';
import { useTemplatesContext } from 'src/sections/@dashboard/templates/hooks/useTemplatesContext';
import TemplatesFormModal from './TemplatesFormModal';

export const TemplatesAddNewButton = () => {
  const { handleOpenModal } = useTemplatesContext();

  return (
    <>
      <Button
        size="medium"
        onClick={() => handleOpenModal()}
        variant="contained"
        color="primary"
        startIcon={<Iconify icon="mdi:add" />}
      >
        Dodaj szablon
      </Button>
      <TemplatesFormModal />
    </>
  );
};
